export const formValidate = {
  validateEmail: function (rule, email, callback) {
    if (email === '') {
      return callback(new Error('邮箱不能为空'))
    }
    // var reg = /^[\w-]+(\.[\w-]+)*@[\w-]+(\.[\w-]+)+$/
    var reg = new RegExp('^([a-z0-9A-Z]+[-|\\.]?)+[a-z0-9A-Z]@([a-z0-9A-Z]+(-[a-z0-9A-Z]+)?\\.)+[a-zA-Z]{2,}$')
    if (!reg.test(email)) {
      return callback(new Error('邮箱格式不正确'))
    }
    callback()
  },
  validatePhone: function (rule, phone, callback) {
    if (phone === '') { return callback(new Error('手机号码不能为空')) }
    // var reg = /^\d{11}$/
    var reg = new RegExp('^((13[0-9])|(15[^4,\\D])|(14[57])|(17[0-9])|(18[0,0-9]))\\d{8}$')
    if (!reg.test(phone)) {
      return callback(new Error('手机号码格式不正确'))
    }
    callback()
  },
  validatePwd: function (rule, pwd, callback) {
    if (pwd === '') {
      return callback(new Error('密码不能为空'))
    }
    var reg = /(?!^[0-9]+$)(?!^[A-z]+$)(?!^[^A-z0-9]+$)^.{6,12}$/

    if (!reg.test(pwd)) {
      return callback(new Error('密码格式不正确'))
    }
    callback()
  },
  validatePwdRepeat: function (pwd, repeatPwd, callback) {
    if (!repeatPwd) {
      return callback(new Error('确认密码不能为空'))
    }
    if (pwd !== repeatPwd) {
      return callback(new Error('您两次输入的密码不一致'))
    }
    callback()
  },
  validateNotNull: function (val, message, callback) {
    if (!val.replace(/\s/g, '')) {
      return callback(new Error(message))
    }
    callback()
  },
  validateMaxLength: function (input, maxLength, message, callback) {
    if (input.length > maxLength) {
      return callback(new Error(message))
    }
    callback()
  }
}



// WEBPACK FOOTER //
// ./src/service/formValidate.js